<template>
  <div v-show="showWebtoonModal">
    <div class="webtoon_modal">
      <div class="overlay"></div>
      <div class="webtoon_modal_position">
        <div class="modal-card">
          <div
            class="webtoon_modal_layout"
            style="padding: 0 !important; border-radius: 5px; overflow: hidden"
          >
            <div class="webtoon_modal_content second" v-if="second" style="padding: 0 !important">
              <Flicking :options="{ circular: false }" :plugins="plugins">
                <img
                  :src="item"
                  class="w-100"
                  style="pointer-events: none"
                  v-for="(item, i) in second"
                  :key="i"
                />
                <template #viewport>
                  <span class="flicking-arrow-prev is-circle"></span>
                  <span class="flicking-arrow-next is-circle"></span>
                  <div class="flicking-pagination"></div>
                </template>
              </Flicking>
            </div>
          </div>
          <div class="webtoon_modal_footer" v-if="second">
            <span class="no_more_modal" @click="noMoreWebtoon">
              {{ this.$router.app._route.name === 'Main' ? '30일 동안 보지 않기' : '&nbsp;' }}
            </span>
            <span
              class="no_more_modal just_close"
              @click="$store.commit('toggleWebtoonModal', { state: false })"
            >
              {{ $t('modal.close') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { AutoPlay, Pagination, Arrow } from '@egjs/flicking-plugins';
export default {
  name: 'Webtoon',
  props: {
    chapter: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    chapter: function () {
      this.getWebtoonContent();
    },
  },
  mounted() {
    this.getWebtoonContent();
  },
  created() {},
  computed: {
    ...mapState({
      showWebtoonModal: (state) => state.showWebtoonModal,
    }),
  },
  data() {
    return {
      plugins: [
        new AutoPlay({ duration: 5000, direction: 'NEXT', stopOnHover: false }),
        new Pagination({ type: 'bullet' }),
        new Arrow(),
      ],
      webtoon_modal_content_first: '',
      second: false,
      id: null,
    };
  },
  methods: {
    isNoMoreModal() {
      const cookie = this.$cookies.get(`noMoreWebtoon_${this.id}`);
      if (cookie) {
        const daysBerweenDates = Math.round(
          Math.abs(new Date(cookie) - new Date(this.toStringByFormatting(new Date()))) /
            (1000 * 60 * 60 * 24)
        );
        this.$router.app._route.name === 'Main'
          ? daysBerweenDates > 29
            ? this.$store.commit('toggleWebtoonModal', { state: true })
            : this.$store.commit('toggleWebtoonModal', { state: false })
          : this.$store.commit('toggleWebtoonModal', { state: false });
      }
    },
    getWebtoonContent() {
      this.$axios
        .get(`${process.env.VUE_APP_TEST_SERVER}/popup/webtoon?chapter=${this.chapter}`)
        .then((response) => {
          const responseData = response.data.data;

          responseData.length !== 0 &&
          (this.$router.app._route.name === 'Main' || this.chapter !== 0)
            ? this.$store.commit('toggleWebtoonModal', { state: true })
            : this.$store.commit('toggleWebtoonModal', { state: false });

          this.second = responseData.content;
          this.id = responseData.id;

          this.$router.app._route.name === 'Main' && this.isNoMoreModal();
        });
    },
    noMoreWebtoon() {
      this.$store.commit('toggleWebtoonModal', { state: false });
      const cookie = `noMoreWebtoon_${this.id}`;
      this.$cookies.set(cookie, this.toStringByFormatting(new Date()), '30d');
    },
    toStringByFormatting(source, delimiter = '-') {
      const year = source.getFullYear();
      const month = String(source.getMonth() + 1).padStart(2, '0');
      const day = String(source.getDate()).padStart(2, '0');
      return [year, month, day].join(delimiter);
    },
  },
};
</script>

<style lang="postcss">
@keyframes open_webtoon_modal {
  from {
    opacity: 0;
  }
   {
    opacity: 1;
  }
}

.webtoon_modal,
.overlay {
  animation: open_webtoon_modal 0.2s;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9;
}
.overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
.webtoon_modal_position {
  display: grid;
  place-items: center;
  height: 75%;
}
.modal-card {
  display: inline-block;
  position: relative;
  max-width: 600px;
  max-height: 90%;
  width: auto;
  margin: auto;
  background-color: white;
  z-index: 11;
  opacity: 1;
  overflow: unset;
  aspect-ratio: 1/1;
  border-radius: 5px;
}
.webtoon_modal_title {
  max-width: 666px;
  background-color: #003277;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.16);
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.22px;
  text-align: center;
  color: #fff;
  position: sticky;
  top: 0;
  padding: 15px 0;
}
.webtoon_modal_title > span {
  padding: 0 40px;
}
.webtoon_modal_layout {
  padding: 60px;
  /* white-space: pre-wrap; */
}
.webtoon_modal_content {
  padding: 20px;
}
.webtoon_modal_content.first {
  background-color: #e8e8e8;
}
.webtoon_modal_content.third {
  margin: 0 40px;
  border: solid 1px #707070;
}
.webtoon_modal_content.fourth {
  padding-bottom: 0;
}
.webtoon_modal_footer {
  text-align: left;
  color: #fff;
  font-weight: 500;
  padding: 7px 14px;
  position: absolute;
  bottom: -38px;
  width: 100%;
}
.important {
  color: red;
}
.important.big {
  font-size: 20px;
}
.no_more_modal {
  cursor: pointer;
}
.no_more_modal.just_close {
  position: absolute;
  right: 14px;
}
@media screen and (max-width: 992px) {
  .modal-card {
    max-width: 80%;
    max-height: 85%;
  }
  .webtoon_modal_title {
    height: 60px;
    font-size: 20px;
    line-height: 60px;
  }
  .webtoon_modal_title > span {
    padding: 0 25px;
  }
  .webtoon_modal_layout {
    word-break: keep-all;
    font-size: 14px;
    padding: 12px;
  }
  .webtoon_modal_content {
    padding: 10px;
  }
  .webtoon_modal_content.third {
    font-size: 12px;
  }
  .important.big {
    font-size: 16px;
  }
  .webtoon_modal_footer {
    font-size: 12px;
  }
}
</style>
